<template>
  <Breadcrumbs />
  <DynamicContent
    id="brand-overview-content"
    class="container dynamic-content"
    :html="pageContentBlock"
  ></DynamicContent>

  <div class="container">
    <BaseTitle>{{ $t("brands.brands-from-a-z") }} </BaseTitle>
    <AlphabetGrid />
  </div>

  <BrandsGrid
    :input="{
      searchFilter,
    }"
    :pagination="{ limit: 15, offset: 0 }"
    :show-load-more="true"
    :title="brandsTitle"
    class="mb-4"
  />
</template>

<script setup lang="ts">
import { useRouteQuery } from "@vueuse/router";
import { SearchFilter, useWebsitePageQuery } from "~/graphql/generated";
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    "nl-NL": "/merken",
    fr: "/marques",
    nl: "/merken",
  },
});

const activeChar = useRouteQuery("startsWith", "", {
  transform: String,
});

const searchFilter = computed(
  () => SearchFilter[activeChar.value as keyof typeof SearchFilter],
);

const { t } = useI18n();
const brandsTitle = computed(() => {
  if (activeChar.value)
    return t("brands.brands-starting-with", [activeChar.value]);
  return t("brands.popular-brands");
});

// Set the (optional) page content blocks
const path = useRoute().path;
const { websitePagePath } = useWebsitePagePath(path);

// Currently the type of `page` gives us errors that contentBlocks doesn't exist (it does), so we sprinkle @ts-expect-error here and there.
const page = await useWebsitePageQuery({
  variables: websitePagePath,
});

const pageContentBlock = computed(() => {
  return page.data.value?.websitePage &&
    // @ts-expect-error
    page.data.value?.websitePage?.contentBlocks &&
    // @ts-expect-error
    page.data.value?.websitePage.contentBlocks[0]
    ? // @ts-expect-error
      page.data.value?.websitePage.contentBlocks[0]
    : null;
});
</script>

<style lang="css">
#brand-overview-content  p {
  margin-bottom: 0;
}
</style>
